<template>
  <div
    class="modal fade"
    id="resetPasswordModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="resetPasswordModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-t="'forgotPassword.reset_title'"></h5>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Cerrar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="header-pic">
          <img src="/img/head_login.jpg" />
        </div>
        <div class="modal-body">
          <form
            class="form-signin form-reset-password"
            v-on:submit.prevent="sendForm()"
            data-vv-scope="form_reset_password"
          >
            <input
              type="password"
              id="inputPasswordForgot"
              name="clave"
              class="form-control"
              :placeholder="$t('forgotPassword.inputs.pass')"
              @keypress="withoutSpace($event)"
              v-validate="{ required: true }"
              v-model.trim="form_data.password"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_forgot.clave')"
              >{{ errors_validate.first("form_forgot.clave") }}</span
            >
            <input
              type="password"
              id="inputPasswordRepForgot"
              name="clave_repetir"
              class="form-control"
              :placeholder="$t('forgotPassword.inputs.confirm_pass')"
              @keypress="withoutSpace($event)"
              v-validate="'required'"
              v-model.trim="form_data.password_confirmation"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_forgot.clave_repetir')"
              >{{ errors_validate.first("form_forgot.clave_repetir") }}</span
            >

            <div class="col-md-12 cont-captcha">
              <!-- <vue-recaptcha
                ref="invisibleRecaptcha1"
                :sitekey="sit_ky"
                :loadRecaptchaScript="false"
                recaptchaScriptId="invisibleRecaptcha1"
                size="invisible"
                @verify="onCaptchaVerified"
                @expired="onExpired"
              ></vue-recaptcha> -->
            </div>

            <div class="bt-signin-box">
              <button
                class="material-btn bt_red"
                type="submit"
                :disabled="is_send"
                v-t="'forgotPassword.actions.forgot'"
              ></button>
            </div>
            <span
              v-for="(item, err_key) in list_errors_c"
              :key="err_key"
              class="error text-danger"
              >{{ item }}</span
            >
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Snackbar from "node-snackbar";
import _ from "lodash";

import * as auth_request from "../../request/auth.js";
import AuthMixins from "../../mixins/auth.js";

export default {
  props: {
    validateRecaptcha: {
      type: Function,
      default: () => {},
    },
    resetTheRecaptcha: {
      type: Function,
      default: () => {},
    },
  },
  mixins: [AuthMixins],
  mounted() {
    $(document).ready(function () {
      $("#resetPasswordModal").on("show.bs.modal", function () {
        document.getElementById("app").style.position = "relative";
      });

      $("#resetPasswordModal").on("hidden.bs.modal", function () {
        document.getElementById("app").style.position = null;
      });
    });
  },
  data() {
    return {
      form_data: {
        token: "",
        email: "",
        password: "",
        password_confirmation: ""
      },
      is_send: false,
      list_errors: {},
    };
  },
  computed: {
    list_errors_c: function () {
      let result = [];
      _.forIn(this.list_errors, (element, key) => {
        _.forEach(element, (subElement) => {
          result.push(this.$t("alert." +subElement));
        });
      });
      return result;
    },
  },
  methods: {
    show(token, email) {
      this.form_data.token = token;
      this.form_data.email = email;

      $("#resetPasswordModal").modal("show");
    },
    withoutSpace: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 32) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    sendForm() {
      this.$validator.validateAll("form_reset_password").then((result) => {
        if (result) {
          this.validando_captcha = true;
          this.is_send = true;
          this.validateRecaptcha("resetPassword");
        } else {
          // Si el formulario no es valido
          this.is_send = false;
        }
      });
    },
    onCaptchaVerified(token) {
      this.validando_captcha = false;
      let vm = this;
      let data = new FormData();

      for (const key in this.form_data) {
        if (this.form_data.hasOwnProperty(key)) {
          data.append(key, this.form_data[key]);
        }
      }

      data.append("g-recaptcha-response", token);

      auth_request
        .postResetPassword(data)
        .then((response) => {
          console.log({response});
          this.is_send = false;
          $("#resetPasswordModal").modal("hide");
          $("body").removeClass("modal-open");
          $(".modal-backdrop").remove();

          Snackbar.show({
            text: this.$t("alert.reset_password"),
            pos: "bottom-center",
            backgroundColor: "#1D0E54",
            actionTextColor: "#ee5b66",
            actionText: "<b>" + this.$t("boton.cerrar") + "</b>",
          });

          for (const key in vm.form_data) {
            if (vm.form_data.hasOwnProperty(key)) {
              vm.form_data[key] = "";
            }
          }

          vm.is_send = false;
          setTimeout(() => {
            vm.$validator.reset();
          }, 300);

          setTimeout(() => {
            $("#confirmResetPasswordModal").modal("show");
          }, 800);
        })
        .catch((err_) => {
          console.log({err_});
          vm.list_errors = err_.response.data.errors || err_.response.data.error;
          vm.is_send = false;
        });
    },
  },
};
</script>

<style>
.grecaptcha-badge {
  display: none !important;
}

.form-reset-password .bt-signin-box {
  height: auto;
}

.form-reset-password button[type="submit"] {
  width: auto;
  margin-top: 1rem;
}


</style>

<i18n src="@/locale/modals/generic.json" />
<i18n src="@/locale/modals/forgotPassword.json" />
<i18n src="@/locale/modals/alertas.json" />
